"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _ModalState = _interopRequireDefault(require("../../state-observables/modal/ModalState"));
var _HowToUseModal = _interopRequireDefault(require("../modals/HowToUseModal"));
var _react = require("react");
var _ConnectionArea = _interopRequireDefault(require("../ConnectionArea"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Header(_ref) {
  let {
    isInModal
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.header,
    children: [!!!isInModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConnectionArea.default, {
      isNavMenuMinimized: false
    }), !!!isInModal && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.title,
      children: "Sensor Insights Hub"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: _stylesModule.default.helpButton,
      onClick: () => _ModalState.default.setModal(/*#__PURE__*/(0, _react.createElement)(_HowToUseModal.default, {}), "Discover the Dashboard: A User-friendly Guide!"),
      children: "HELP"
    })]
  });
}